/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT.
// Source: src/app/shared/schemas/ui-config.schema.json
// Regenerate: pnpm run generate:ui-config-types

/** The schema `version` this build's types were generated from. */
export const UI_CONFIG_SCHEMA_VERSION = '1.13.0';

/**
 * Single filter definition; alias of FilterDefinition.
 */
export type FilterDef = {
  [k: string]: unknown;
} & {
  field: string;
  label: string;
  /**
   * IMPORTANT (GF-4915): a LITERAL PHYSICAL column of the tenant's performance_dashboard table — there is no mapping layer for filter columns (unlike table columns, which have fieldMappings/dbFieldName). The value reaches the wire verbatim on both the column-values fetch and the in/not_in query filters, and an unknown name returns 400 (see common/validators/columns.py and common/models/filters.py validate_against_tables). A mapped, logical, or camelCase UI name will fail at query time, not at save time.
   */
  column: string;
  type: FilterType;
  source: FilterSource;
  /**
   * GF-4915: the fixed value list a `static` filter (source: 'static') picks from — see FilterDefinition.options in filter.model.ts. Meaningless for source: 'api', which fetches its options from the column-values endpoint instead.
   */
  options?: string[];
  fetchDistinct: boolean;
  orderDirection: OrderDirection;
  pluralLabel?: string;
  displayFormat?: DisplayFormat;
  defaultOperator?: FilterOperator;
  defaultValue?: string[];
  isSearchable?: boolean;
  isEnabled?: boolean;
  /**
   * GF-4170: marks the filter whose column partitions the tenant's CMI agent runs (e.g. division_name). At most one filter per tenant should set this.
   */
  isPartition?: boolean;
  /**
   * When false, this filter's default value is not auto-applied to the CMI insights feed (it still scopes the dashboard charts/tables). Applies to insights again once the user changes it away from the default. Defaults to true when omitted.
   */
  applyToInsights?: boolean;
  /**
   * Page keys this filter is offered on. When present, the filter appears only on the listed pages, whatever `pages.<key>.filters.includeGlobal` or `allowedIds` say. When omitted, the filter is offered on every page unless a page restricts it. Two filters may share a `column` when their `pages` lists are disjoint.
   *
   * @minItems 1
   */
  pages?: [
    (
      | 'home'
      | 'customer-performance'
      | 'product-performance'
      | 'sales-rep-performance'
      | 'scorecard'
      | 'pricing'
      | 'pricing-impact'
      | 'pricing-action-margin'
    ),
    ...(
      | 'home'
      | 'customer-performance'
      | 'product-performance'
      | 'sales-rep-performance'
      | 'scorecard'
      | 'pricing'
      | 'pricing-impact'
      | 'pricing-action-margin'
    )[],
  ];
};
/**
 * GF-4915: widened to match what the client already honors. `FilterDefinition.type` in filter.model.ts accepts both values. `dateRange` was removed (GF-5324) — it never had runtime support (schema.adapter.ts silently dropped any filter typed this way); the dashboard's date range is a separate, hardcoded `date_range` selection owned by filter.facade.ts/filter-bar.ts.
 */
export type FilterType = 'multi' | 'boolean';
/**
 * GF-4915: widened to match filter.model.ts. `api` fetches options from the column-values endpoint; `static` uses the fixed `FilterDef.options` array instead.
 */
export type FilterSource = 'api' | 'static';
/**
 * GF-4915: widened to match filter.types.ts, which types `orderDirection` as 'asc' | 'desc' and passes it straight through to the column-values fetch.
 */
export type OrderDirection = 'asc' | 'desc';
export type DisplayFormat = 'dateOnly';
export type FilterOperator = 'in' | 'not_in';
/**
 * Display formatting category for a metric or scorecard KPI.
 */
export type MetricType = 'percentage' | 'price' | 'quantity' | 'revenue' | 'ratio';
/**
 * PrimeIcons class string, e.g. 'pi pi-box'.
 */
export type IconClass = string;
/**
 * Discriminated union of metric data sources. The 'type' const selects the arm.
 */
export type MetricDataSource =
  | ApiMetricDataSource
  | StaticMetricDataSource
  | CompositeMetricDataSource;
/**
 * HTTP method used by an api-typed metric data source.
 */
export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';
/**
 * GF-5143: entity kind a metric's drill-down member list is drawn from. Matches Terminology's keys 1:1 so the drill affordance and drawer title can reuse the tenant's entity-name override.
 */
export type MetricDrillEntityType = 'sales_rep' | 'customer' | 'product';
/**
 * Column data type for rendering and parsing.
 */
export type ColumnDataType =
  | 'currency'
  | 'date'
  | 'decimal'
  | 'integer'
  | 'percent'
  | 'text'
  | 'ratio';
export type Alignment = 'left' | 'center' | 'right';
/**
 * GF-4915: widened to match data-table.models.ts, which types avatarType as 'initials' | 'icon'. `initials` derives a monogram from the row value; `icon` renders `avatarIcon`.
 */
export type AvatarType = 'initials' | 'icon';
export type PercentScale = 'fraction' | 'whole';
export type TrendPosition = 'left' | 'right';
/**
 * GF-4915: widened to match the implemented branches in table-config.adapter.ts mapRow — `number` coerces to Number, `percentToDecimal` divides by 100.
 */
export type MappingTransform = 'number' | 'percentToDecimal';
export type CellTreatment = 'none' | 'heatmap' | 'comparison' | 'sign';
/**
 * Chart rendering type. Mirrors the runtime ChartType union in gf-insights-ui (src/app/shared/models/chart.model.ts). Two semantic variants ('stacked-horizontal-bar', 'waterfall') ultimately render as Chart.js 'bar' via per-type option builders.
 */
export type ChartType =
  | 'bar'
  | 'line'
  | 'scatter'
  | 'bubble'
  | 'pie'
  | 'doughnut'
  | 'polarArea'
  | 'radar'
  | 'stacked-horizontal-bar'
  | 'waterfall';

/**
 * Tenant UI configuration schema for GF Insights. Validates the per-tenant config JSON files consumed by the Angular app to drive page layouts, filters, metric registries, data tables, and scorecard business-summary cards.
 */
export interface UIConfig {
  filters: {
    /**
     * Filter definitions keyed by filter id. Display order is NOT this object's key order (GF-5411): Postgres JSONB does not preserve object-key insertion order across a save/reload round trip, so a tool that round-trips this config through a key-sorting (or any JSONB-backed) serializer can silently reorder the tenant's filter panel. Order is instead carried explicitly by the sibling `filterOrder` array. CAVEAT (applies regardless of `filterOrder`): JS property enumeration always visits integer-index-like keys ('0', '1', '23', ...) first, in ascending numeric order, ahead of any string key. `filterOrder` fixes the config-storage round trip, but the UI re-materializes filters into plain object literals several times downstream during render, and each of those hops re-triggers this same key-enumeration rule regardless of what order they were inserted in. Every existing tenant uses descriptive ids (e.g. 'region', 'segment'), so use one here too.
     */
    filters: {
      [k: string]: FilterDef;
    };
    /**
     * Explicit display order for `filters` (GF-5411), as a list of filter ids. The runtime (schema.adapter.ts) sorts `filters` by this array, falling back to the object's own key order when absent (configs saved before this field existed) or for any id missing from it. Ids no longer present in `filters` are ignored. NOTE: a tenant published before 1.6.0 has no `filterOrder`, and its `filters` key order in Postgres JSONB may already be scrambled relative to what was last intended; the fallback preserves whatever order JSONB currently holds, not the originally-intended one. A publish through the admin UI self-heals this: `confirmPublish` in admin-configs.ts backfills `filterOrder` from the current `filters` key order whenever it's absent, regardless of what the admin actually edited, so a tenant is pinned onto the explicit field by its very next admin-UI publish. This backfill is client-side only — a direct API (`POST .../ui-config/publish` with a body config) or CLI (`publish_ui_config.py`) publish goes through `UiConfigService.publish` unchanged and does NOT backfill, so a legacy config published that way can still be missing `filterOrder`.
     */
    filterOrder?: string[];
    /**
     * When true, each filter's option list is narrowed to values that co-occur with the other filters' current selections (fetched server-side when the filter is opened). Defaults to false when omitted: every filter shows its full, independent option list.
     */
    progressive?: boolean;
  };
  /**
   * Page-key -> page config map keyed by the PageKey enum (src/app/shared/models/page-key.enum.ts in gf-insights-ui). Every tenant must define 'home', 'customer-performance', 'product-performance', and 'sales-rep-performance'; 'scorecard' (business-summary feature) and 'pricing' (CMI Impact/Adherence pricing screens) are optional and only present on tenants that enable those features. 'pricing-action-margin' is optional; it structurally accepts any PageConfig feature, and is used today only for the Pricing Action Loop margin queue's per-tenant table presentation (features.tables.columnOrderOverrides).
   */
  pages: {
    home: PageConfig;
    'customer-performance': PageConfig;
    'product-performance': PageConfig;
    'sales-rep-performance': PageConfig;
    scorecard?: PageConfig;
    pricing?: PageConfig;
    'pricing-impact'?: PageConfig;
    'pricing-action-margin'?: PageConfig;
  };
  terminology?: Terminology;
  /**
   * Tenant-level display-formatting knobs applied app-wide (GF-4529).
   */
  formatting?: {
    /**
     * Max fraction digits for UNIT-PRICE displays (min stays 2; trailing zeros beyond cents are trimmed, so 4 renders $0.0475 / $0.05 — never $0.0500). Applies only to sub-dollar values; values >= $1 keep the classic 2-decimal render. Omit (or 2) for the classic rendering everywhere — e.g. 4 lets a small-price tenant (~$0.05 items) show distinguishable unit prices.
     */
    priceDecimalPlaces?: number;
    /**
     * GF-4605: how realized unit PRICE renders app-wide — 'currency' (default, $) or 'ratio' (a unit-less multiplier like everflow's ~0.20). Revenue/order-size stay $ regardless.
     */
    priceBasis?: 'currency' | 'ratio';
    /**
     * GF-4605: word shown for the price axis/legend/columns — 'Price' by default, e.g. 'Multiplier' for everflow.
     */
    priceLabel?: string;
  };
}
/**
 * Single page configuration; alias of UIPageConfig.
 */
export interface PageConfig {
  features?: UIConfigFeatures;
  /**
   * Per-page filter scoping. Defaults to including all global filters when omitted.
   */
  filters?: {
    /**
     * Explicit list of filter ids allowed on this page.
     */
    allowedIds?: string[];
    /**
     * If true (default), include all global filters in addition to allowedIds.
     */
    includeGlobal?: boolean;
  };
}
export interface UIConfigFeatures {
  metrics?: MetricsFeatureConfig;
  tables?: TablesFeatureConfig;
  charts?: ChartsFeatureConfig;
  businessSummary?: ScorecardBusinessSummaryConfig;
  customerAnalysis?: ScorecardCustomerAnalysisConfig;
  guidance?: GuidanceFeatureConfig;
}
export interface MetricsFeatureConfig {
  registry: {
    [k: string]: MetricDef;
  };
  selection: MetricSelectionConfig;
  /**
   * Optional grouping layer over the registry.
   */
  groups?: MetricGroup[];
}
/**
 * Single metric definition; alias of MetricDefinition.
 */
export interface MetricDef {
  id: string;
  display: MetricDisplayOptions;
  /**
   * Optional grouping or filtering tags.
   */
  tags?: string[];
  dataSource?: MetricDataSource;
  drill?: MetricDrillConfig;
}
export interface MetricDisplayOptions {
  label: string;
  type: MetricType;
  showPercentageChange?: boolean;
  unit?: string;
  isPercentagePointMetric?: boolean;
  description?: string;
  decimalPlaces?: number;
  icon?: IconClass;
  color?: string;
  /**
   * Optional value-formatting hint, e.g. 'currency', 'compact'.
   */
  format?: string;
}
/**
 * Metric data source backed by a declarative API request mapping.
 */
export interface ApiMetricDataSource {
  type: 'api';
  method: HttpMethod;
  /**
   * Path to the container (object or array element) holding current/compare/pct_change values.
   */
  valuePath: string;
  unit?: string;
  /**
   * Declarative mapping (date | filters | literal | metric). Inner shape is intentionally open.
   */
  requestBody: {};
}
/**
 * Metric data source returning a fixed value.
 */
export interface StaticMetricDataSource {
  type: 'static';
  staticValue: number | string | null;
  unit?: string;
}
/**
 * Metric data source derived from other metrics via a formula or resolver.
 */
export interface CompositeMetricDataSource {
  type: 'composite';
  /**
   * Other metric ids referenced by the formula or resolver.
   */
  dependsOn?: string[];
  unit?: string;
}
/**
 * GF-5143: marks this metric tile as drillable. Presence of this field on a MetricDef is what makes the tile clickable and shows the drill affordance — a tile whose value has no definable member population (e.g. an average) must omit it and stays inert. The member list is fetched from POST /dashboard/data-metrics/{id}/drill, where {id} is this MetricDef's own id; no separate target identifier is needed, since the backend registers at most one drill population per metric (gf_insights_api.data_metric.repository.drill_strategy).
 */
export interface MetricDrillConfig {
  entityType: MetricDrillEntityType;
  /**
   * Optional override for the drill affordance / drawer-title copy. Omit to derive it from entityType via Terminology (e.g. 'View products').
   */
  label?: string;
}
export interface MetricSelectionConfig {
  defaultMetricIds: string[];
  /**
   * Metric ids that are always shown and cannot be deselected.
   */
  requiredMetricIds?: string[];
  /**
   * Metric ids that exist in the registry but are not user-selectable.
   */
  hiddenMetricIds?: string[];
  /**
   * Optional cap on the number of concurrently selected metrics.
   */
  maxSelectable?: number;
  allAvailableMetricIds?: string[];
  persistSelection?: boolean;
  ordering?: string[];
}
/**
 * Logical grouping of metrics for layout and ordering.
 */
export interface MetricGroup {
  id: string;
  label: string;
  metricIds: string[];
  /**
   * Layout hint: number of columns to render this group across.
   */
  columns?: number;
  /**
   * Ordering weight; lower renders earlier.
   */
  order?: number;
  description?: string;
}
export interface TablesFeatureConfig {
  registry: {
    [k: string]: TableDefinition;
  };
  /**
   * Per-tenant column header overrides for code-defined tables that do NOT live in `registry` (their definition is hard-coded in the UI). Keyed by tableId, then by column field, to the override header text. Lets a tenant relabel a single hard-coded column (e.g. EMS coaching-insights `entityId` -> "Territory") without redefining the whole table. Columns not listed keep their code-defined header.
   */
  columnHeaderOverrides?: {
    [k: string]: {
      [k: string]: string;
    };
  };
  /**
   * Per-tenant left-to-right column order for code-defined tables that do NOT live in `registry`. Keyed by tableId to an array of column `field` names. Presentation only: the fields listed render first in this order, fields not listed keep their code-defined order and follow them, a name that matches no column is ignored, and a column whose position is structural (the grouping column) stays first. Never affects the CSV export, which the server builds.
   */
  columnOrderOverrides?: {
    [k: string]: string[];
  };
  /**
   * Per-tenant columns hidden BY DEFAULT for code-defined tables that do NOT live in `registry`. Keyed by tableId to an array of column `field` names. A starting point, not a lock: on a table whose column chooser can reach the field, a user may show it again for their own session. A name that matches no column is ignored, and a column whose position is structural (the grouping column) is never hidden. A client-built CSV export reflects it, because those export what is on screen; a server-built export does not.
   */
  hiddenColumnOverrides?: {
    [k: string]: string[];
  };
  /**
   * Per-tenant cell treatment for code-defined tables that do NOT live in `registry`. Keyed by tableId, then by column field, to a `ColumnDef.cellTreatment` value that replaces the code-defined one. `none` turns a default treatment off. A tableId or field that matches nothing is ignored.
   */
  cellTreatmentOverrides?: {
    [k: string]: {
      [k: string]: CellTreatment;
    };
  };
}
export interface TableDefinition {
  id: string;
  label: string;
  defaultSortField: string;
  defaultSortOrder: 1 | -1;
  columns: ColumnDef[];
  fieldMappings: TableFieldMapping[];
  pageSize: number;
  chunkSize: number;
  hideSortInTruncatedView?: boolean;
  /**
   * Drill-down column layout, indexed by depth. Phase 1 keeps the inner column shape permissive; tighten in a follow-up.
   */
  columnsByDepth?: {
    [k: string]: unknown;
  }[][];
  /**
   * Grouping options for the table (array of option objects). Phase 1 keeps the inner shape permissive.
   */
  groupOptions?: {
    [k: string]: unknown;
  }[];
  /**
   * Inline drilldown config. Phase 1 keeps the inner shape permissive.
   */
  drilldown?: {
    [k: string]: unknown;
  };
  /**
   * Drill-down page navigation config. Phase 1 keeps the inner shape permissive.
   */
  drillDownPageConfig?: {
    [k: string]: unknown;
  };
  /**
   * Row-popover config. Phase 1 keeps the inner shape permissive.
   */
  popOverConfig?: {
    [k: string]: unknown;
  };
  /**
   * Row-level action controls (kebab menu, etc.). Phase 1 keeps the inner shape permissive.
   */
  actionControls?: {
    [k: string]: unknown;
  }[];
  /**
   * Tooltip/info-popover content. Phase 1 keeps the inner shape permissive.
   */
  infoContent?: {
    [k: string]: unknown;
  };
  /**
   * Free-text caption shown alongside the table.
   */
  supportingText?: string;
  /**
   * How this table presents the 'Compare To' period. Omit it entirely and no comparison is requested — which also spares the second aggregation the API would otherwise run per request.
   */
  comparison?: {
    /**
     * off — no comparison requested (same as omitting the block); an explicit value so the admin editor can turn it off. inline — each column set to `cellTreatment: "comparison"` shows its change alongside its value, with the compare-period value on hover. The enum stays open for further cell treatments.
     */
    display: 'off' | 'inline';
  };
}
/**
 * Runtime column definition for a table column.
 */
export interface ColumnDef {
  field: string;
  header: string;
  type: ColumnDataType;
  sortable: boolean;
  /**
   * When false, the column is hidden from end users. Defaults to true (shown) when omitted.
   */
  visible?: boolean;
  align?: Alignment;
  abbreviate?: boolean;
  clickable?: boolean;
  headerMaxWidth?: string;
  minWidth?: string;
  paddingClass?: string;
  avatar?: boolean;
  avatarType?: AvatarType;
  avatarIcon?: IconClass;
  /**
   * Optional value-formatting hint (e.g. Angular DecimalPipe digitsInfo '1.0-1').
   */
  format?: string;
  /**
   * Fraction digits for the column's numeric values (currency price/cost and decimal columns). Omit to keep the type default (2 for currency prices) — e.g. 4 lets a sub-dollar tenant render $0.0525 instead of $0.05 (GF-4529).
   */
  decimalPlaces?: number;
  percentScale?: PercentScale;
  showTrend?: boolean;
  trendField?: string;
  trendPosition?: TrendPosition;
  trendPrefix?: string;
  filterable?: boolean;
  filterType?: string;
  /**
   * GF-4885: optional muted second line rendered under the cell value. `template` is interpolated with double-brace placeholders resolved against the mapped row, so `{{ customerDescription }}` renders the tenant's customer_desc_col (e.g. an account number) beneath the customer name. Reference the UI-side field name from `fieldMappings`, not the backend column; single braces render as literal text. Surrounding literal text is preserved — e.g. 'Acct {{ customerDescription }}'. Avoid `%` or `$` in the template: the interpolator numerically rescales the value when either character is present.
   */
  subText?: {
    template: string;
  };
  /**
   * @deprecated
   * Superseded by `cellTreatment`, which says the same thing without letting a column ask for two treatments at once. Still read when `cellTreatment` is absent, so a config published before the change keeps working; true here means the same as `cellTreatment: "comparison"`.
   */
  compareToPrior?: boolean;
  /**
   * Which single visual encoding this column's cells carry. heatmap — a background gradient ranking the value within its column; useful on a column the grid is not sorted by, since row order already carries rank on the one it is. sign — a success tint on positive values and an error tint on negative ones, for a signed measure such as an impact or a variance where the direction is the message; zero, a value that rounds to zero, and blanks stay plain. comparison — the change against the compare window, shown beside the value, with the compare-period value on hover; only honoured for metrics the API can compare — the aggregates the dimension projects, currently thirteen, mirrored in the client's COMPARABLE_BACKEND_METRICS — and only when the table sets `comparison.display`. One value rather than independent flags because each encodes a number onto the same cell in the same red-green vocabulary, and a cell carrying two leaves the reader no way to tell which scale answers which question. Omit to leave the column plain, or to fall back to the page's own heatmap defaults where it has them.
   */
  cellTreatment?: 'none' | 'heatmap' | 'comparison' | 'sign';
}
/**
 * Maps a backend snake_case field to a UI camelCase field.
 */
export interface TableFieldMapping {
  backend: string;
  ui: string;
  /**
   * Literal physical DB column (or computed-column alias) backing this mapping. gf-insights-ui's DataTableComponent (resolveBackendKey, currentSortCol) explicitly PREFERS this over `backend` when resolving the sort/filter column for its API requests — it is not merely forwarded as an ordinary value, the client interprets it specially before the request. Whichever value it resolves to is validated like any other column at query time in THIS repo (GF-4915). Same constraint as FilterDef.column: not a mapped or UI name, and a wrong value surfaces as a 400 at query time. Note the runtime type in data-table.models.ts declares this required while the schema leaves it optional.
   */
  dbFieldName?: string;
  transform?: MappingTransform;
}
/**
 * Per-page chart registry keyed by ChartDef.id.
 */
export interface ChartsFeatureConfig {
  registry: {
    [k: string]: ChartDef;
  };
}
/**
 * Single chart definition; the config-time subset of the runtime ChartConfig (gf-insights-ui src/app/shared/models/chart.model.ts). Every field is optional so an entry can override just part of a code-defined chart: an omitted field keeps that chart's built-in default. Consumed today by the home chart only, at pages.home.features.charts.registry['net-realization'] (GF-5832).
 */
export interface ChartDef {
  /**
   * Chart id; defaults to the registry key when omitted.
   */
  id?: string;
  type?: ChartType;
  title?: string;
  /**
   * Single-line subtitle or a paragraph list rendered under the title.
   */
  subtitle?: string | string[];
  infoContent?: string;
  /**
   * Height class for the chart box: a PrimeFlex utility (e.g. 'h-15rem') or a global class (e.g. 'pricing-chart-h'). Sizes every chart state (chart, loading skeleton, error, empty) so none of them shifts the layout. Defaults to 'h-25rem' when omitted.
   */
  heightClass?: string;
  axes?: ChartAxesDef;
  /**
   * Per-series overrides keyed by the chart's series id. The home chart's ids are price, cost, revenue and profit; an unknown id is ignored.
   */
  series?: {
    [k: string]: ChartSeriesDef;
  };
}
/**
 * Axis overrides for a dual-axis chart: left is the primary y-axis, right the secondary.
 */
export interface ChartAxesDef {
  left?: ChartAxisDef;
  right?: ChartAxisDef;
}
export interface ChartAxisDef {
  /**
   * Axis title; blank or omitted keeps the default.
   */
  title?: string;
}
/**
 * Override for one chart series.
 */
export interface ChartSeriesDef {
  /**
   * Legend and tooltip label; blank or omitted keeps the default.
   */
  label?: string;
  /**
   * false hides the series. true cannot force a series with no data to show.
   */
  visible?: boolean;
}
export interface ScorecardBusinessSummaryConfig {
  kpis?: BusinessSummaryKpiConfig[];
  combinedTables?: CombinedBusinessMetricsConfig[];
  bottomKpis?: BusinessSummaryKpiConfig[];
}
/**
 * Single KPI tile in the scorecard Business Summary row.
 */
export interface BusinessSummaryKpiConfig {
  cardId: string;
  label: string;
  type: MetricType;
  isPercentagePointMetric?: boolean;
  unit?: string;
  decimalPlaces?: number;
  icon?: IconClass;
  /**
   * When false the card is hidden from the scorecard. Absent or true means shown.
   */
  isVisible?: boolean;
  /**
   * Lower-is-better metric: the trend arrow keeps its direction but the color sentiment inverts (increase renders red). Absent falls back to the concentration-KPI defaults in the scorecard view-model builder (GF-4600).
   */
  invertTrend?: boolean;
}
export interface CombinedBusinessMetricsConfig {
  id: string;
  titlePrefix: string;
  subtitle?: string;
  /**
   * GF-4148 — static prefetched breakdown views (e.g. Top 10 Products / Customers via `revenue_by_top_product` and `revenue_by_top_customer`).
   */
  dimensions?: CombinedBusinessMetricsDimension[];
  /**
   * GF-4092 / GF-4148 / GF-4460 — breakdown card whose server-emitted `available_dimensions` populate the dropdown. The API enumerates `customer_hierarchy_cols` + `product_hierarchy_cols` from the tenant's insights-column-mapping DynamoDB record; labels echo each entry's `ui_header`. Required — there is no code-side default host.
   */
  hierarchyHostCardId: string;
}
/**
 * Static breakdown dimension on the combined Business Metrics card. Rows come from the prefetched breakdown card (local row swap; no refetch on selection).
 */
export interface CombinedBusinessMetricsDimension {
  /**
   * API breakdown card id, e.g. `revenue_by_top_product` or `revenue_by_top_customer`.
   */
  cardId: string;
  /**
   * Dropdown label, e.g. Top 10 Products.
   */
  dimensionLabel: string;
  /**
   * PrimeIcons class string, e.g. 'pi pi-box'.
   */
  avatarIcon?: string;
}
/**
 * Customer Analysis section config. Reserved for future tenant-tunable content; currently an empty object since the detail cards render unconditionally via a dedicated component.
 */
export interface ScorecardCustomerAnalysisConfig {}
/**
 * Optional 'pages.pricing.features.guidance' block for the Adherence + Impact tabs (GF-4603). Every field is optional; a tenant without it gets the code defaults.
 */
export interface GuidanceFeatureConfig {
  /**
   * Page-global custom filters for the guidance tabs (e.g. everflow's 'source' filter defaulted to 'everflow'). An option value of '' means All (no filter applied).
   */
  customFilters?: {
    /**
     * Physical dashboard column the filter scopes on. Same constraint as FilterDef.column (GF-4915): emitted verbatim as `col` in the guidance tabs' column_filters payload (adherence.ts, impact.ts), so a mapped or logical name returns 400 at query time.
     */
    col: string;
    label: string;
    options: {
      value: string;
      label: string;
    }[];
    defaultValue: string;
  }[];
  /**
   * Config-driven labels for the two price-sheet-relative metrics (GF-4603); tenant overrides layered over defaults.
   */
  labels?: {
    priceSheetOrHigher?: string;
    pctToPriceSheet?: string;
  };
  /**
   * Impact page settings. Every field is optional; absent fields keep the code defaults (the six default KPI cards, both charts shown).
   */
  impact?: {
    /**
     * KPI cards to show on Impact, in display order. Absent means the six default cards; an entry's label replaces the card title (otherwise the guidance labels and built-in titles apply).
     *
     * @minItems 1
     */
    kpiCards?: [
      {
        /**
         * Card metric. priceSheetOrHigherLines and pctToPriceSheet take the tenant wording from 'labels' unless this entry sets its own label.
         */
        metric:
          | 'priceImpact'
          | 'targetImpact'
          | 'priceSheetOrHigherLines'
          | 'floorOrHigherLines'
          | 'avgMultiplier'
          | 'pctToPriceSheet';
        label?: string;
      },
      ...{
        /**
         * Card metric. priceSheetOrHigherLines and pctToPriceSheet take the tenant wording from 'labels' unless this entry sets its own label.
         */
        metric:
          | 'priceImpact'
          | 'targetImpact'
          | 'priceSheetOrHigherLines'
          | 'floorOrHigherLines'
          | 'avgMultiplier'
          | 'pctToPriceSheet';
        label?: string;
      }[],
    ];
    /**
     * Show the Impact over time chart. Defaults to true.
     */
    showImpactOverTime?: boolean;
    /**
     * Show the Volume over time chart. Defaults to true.
     */
    showVolumeOverTime?: boolean;
  };
  /**
   * Performance page settings. Every field is optional; absent fields keep the code defaults (the API's default detail grouping). The chart's grain follows the date range, so it is not configured.
   */
  performance?: {
    /**
     * Physical dimension columns for the detail table's default nesting, in order.
     */
    defaultRows?: string[];
  };
}
/**
 * Per-tenant singular entity-label overrides. Missing key -> built-in default. Closed to sales_rep/customer/product; adding an entity label is a deliberate schema change (version bump), not an open extension point.
 */
export interface Terminology {
  sales_rep?: string;
  customer?: string;
  product?: string;
}
